/* eslint-disable global-require,import/no-unresolved */
import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import {
  Image, Text, TouchableHighlight, View,
} from 'react-native'
import { connect } from 'react-redux'
import styles, { colors } from '../../styles'
import panelStyles from '../../styles/panel'
import textStyles from '../../styles/text'
import LightButton from './LightButton'
import * as ResourceManager from '../methods/ResourceManager'
import { gotoSubPage } from '../../actions/helpers'

function IndicatorLightsOptions(props) {
    const {
      headerText,
      headerTextID,
      t,
    } = props
    return (
      <View style={styles.container}>
        <View style={textStyles.h1Container}>
          <Text style={[textStyles.blueMediumText]} accessibilityLabel={t(headerText)} testID={headerTextID}>{t(headerText)}</Text>
        </View>
        <View style={panelStyles.lightsContainer}>
          <LightButton
            accessibilityLabel={t('access:yellowWavesButton')}
            testID="yellow-waves-btn"
            imageSource={ResourceManager.loadImage('yellow_waves')}
            imageStyle={{ width: 45, height: 45, resizeMode: 'contain' }}
            onPressHandler={() => gotoSubPage('WhichYellowWavesPage', 'yellowWaves')}
            buttonText={t('yellowWavesTitle')}
          />
          <TouchableHighlight
            style={[panelStyles.elevatedContainer, panelStyles.lightButton, panelStyles.cardShadow, panelStyles.cardRounding, { flex: 1 }]}
            onPress={() => gotoSubPage('WhichCallDoctorPage', 'whichDoctor')}
            accessibilityLabel={t('access:callDoctorButton')}
            testID="call-doctor-btn"
            underlayColor="#ddd"
          >
            <View style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
              <Image style={[panelStyles.lightImage, { width: 66, height: 51, resizeMode: 'contain' }]} source={ResourceManager.loadImage('yellow_doc')} />
              <Text style={[{ paddingHorizontal: 38, color: colors.shark_grey }, panelStyles.panelText]}>{t('orText')}</Text>
              <Image style={[panelStyles.lightImage, { width: 66, height: 51, resizeMode: 'contain' }]} source={ResourceManager.loadImage('red_doc')} />
            </View>
          </TouchableHighlight>
          <LightButton
            accessibilityLabel={t('access:flashingHeartButton')}
            testID="flashing-heart-btn"
            imageSource={ResourceManager.loadImage('flashing_heart')}
            onPressHandler={() => gotoSubPage('FlashingHeartButtonPage', 'flashingHeart')}
          />
          <LightButton
            accessibilityLabel={t('access:solidGreenWavesButton')}
            testID="all-green-btn"
            imageSource={ResourceManager.loadImage('green_state')}
            imageStyle={{
            width: 241,
            height: 52,
            resizeMode: 'contain',
          }}
            onPressHandler={() => gotoSubPage('AllGreenButtonPage', 'allGreen')}
          />
          <LightButton
            accessibilityLabel={t('access:noLightsButton')}
            testID="no-lights-btn"
            imageSource={ResourceManager.loadImage('no_lights')}
            imageStyle={{
            width: 241,
            height: 52,
            resizeMode: 'contain',
          }}
            onPressHandler={() => gotoSubPage('NoLightsButtonPage', 'noLights')}
            buttonText={t('common:noLightsTitle')}
          />
          <LightButton
            accessibilityLabel={t('access:flashingYellowLightButton')}
            testID="latitude-indicator-btn"
            imageSource={ResourceManager.loadImage('lat_light')}
            imageStyle={{
            width: 107,
            height: 31,
            resizeMode: 'contain',
          }}
            onPressHandler={() => gotoSubPage('LatitudeIndicatorPage', 'flashingLatitude')}
            buttonText={t('common:flashingLatLightTitle')}
          />
        </View>
      </View>
    )
}

IndicatorLightsOptions.propTypes = {
  headerText: PropTypes.string.isRequired,
  headerTextID: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

const actionCreators = {
}

export const IndicatorLightsOptionsComponent = IndicatorLightsOptions

export default withTranslation(['indicatorLights', 'common'])(connect(null, actionCreators)(IndicatorLightsOptions))
